import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const BreezeSendIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BreezeSend",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.48 1.98c-.66-.58-1.57-.75-2.36-.43L3.07 10.42c-1.35.42-2.25 1.49-2.36 2.81-.1 1.19.48 2.27 1.48 2.76 1.02.5 4.47 2.35 6.88 3.66.34.18.75.15 1.06-.09l11.36-8.79c.32-.22.69.2.43.49l-9.47 10.48c-.25.28-.3.69-.12 1.02l4.03 7.33c.48.75 1.31 1.18 2.22 1.18.12 0 .25-.01.37-.03 1.36-.17 2.51-1.18 2.99-2.63L30.17 4.3c.23-.85-.03-1.74-.69-2.32"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M20.23 29.1c-1.02 0-2-.4-2.75-1.15l-5.12-5.12c-.65-.65-1-1.51-1-2.43s.36-1.78 1.01-2.42l6.46-6.46a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-6.46 6.46c-.22.22-.33.5-.33.81s.12.59.34.81l5.12 5.12c.42.42 1 .57 1.57.42s1-.58 1.15-1.15l4.94-18.42c.15-.57 0-1.15-.42-1.57s-1-.57-1.57-.42L6.35 10.14c-.57.15-1 .58-1.15 1.15s0 1.15.42 1.57l3.67 3.67c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0L4 14.48c-1-1-1.38-2.41-1.01-3.78s1.4-2.4 2.77-2.77l18.42-4.94c1.37-.36 2.78.01 3.78 1.01s1.38 2.41 1.01 3.78L24.03 26.2c-.37 1.37-1.4 2.4-2.77 2.77-.34.09-.69.14-1.03.14Z"
      })
    })
  }));
};
BreezeSendIcon.displayName = 'BreezeSendIcon';